module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      'open active': _vm.isOpen
    }
  }, [(_vm.item.children && _vm.item.children.length) ? [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.changeOpen
    }
  }, [_c('span', {
    staticClass: "title fs-14 f-40"
  }, [_vm._v(_vm._s(_vm.item.label)), _c('span', {
    class: ['arrow icon-angle-left iconfont', {
      'open active': _vm.isOpen
    }]
  })]), _c('span', {
    staticClass: "icon-thumbnail",
    class: {
      'bg-complete': _vm.item.isCurrent
    }
  }, [_c('i', {
    staticClass: "iconfont",
    class: ['icon-' + _vm.item.icon]
  })])]), _c('ul', {
    staticClass: "sub-menu",
    class: {
      'open': _vm.isOpen
    }
  }, _vm._l((_vm.item.children), function(child, index) {
    return _c('NavItem', {
      key: child.id,
      attrs: {
        "item": child
      }
    })
  }))] : [_c('router-link', {
    staticClass: "lastLink",
    attrs: {
      "to": _vm.item.url
    }
  }, [_c('span', {
    staticClass: "title fs-14 f-34"
  }, [_vm._v(_vm._s(_vm.item.label))]), _c('span', {
    staticClass: "icon-thumbnail",
    class: {
      'bg-complete': _vm.item.isCurrent
    }
  }, [_c('i', {
    staticClass: "iconfont",
    class: ['icon-' + _vm.item.icon]
  })])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1476ffe0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Home/Sidebar/NavItem.vue
// module id = 1699
// module chunks = 1